import { Link } from 'react-router-dom';
import { MdDashboard, MdReviews } from 'react-icons/md';
import { BsBox2HeartFill, BsCheckAll } from 'react-icons/bs';
import { IoMdCreate } from 'react-icons/io';
import { FaThList } from 'react-icons/fa';
import { HiUsers } from 'react-icons/hi';
import { Accordion } from 'react-bootstrap';

const Sidebar = () => {
    return (
        <div className='adminSidebar'>
            <Link className='logo' to='/'>
                <img src='/assets/images/logo.png' alt='' />
            </Link>
            <div className='adminSidebarOptions'>
                <Link to='/admin/dashboard'>
                    <MdDashboard /> Dashboard
                </Link>
                <Accordion>
                    <Accordion.Item eventKey='0' className='MultiMenu'>
                        <Accordion.Header>
                            <BsBox2HeartFill /> Products
                        </Accordion.Header>
                        <Accordion.Body>
                            <Link to='/admin/products'>
                                <BsCheckAll /> All
                            </Link>
                            <Link to='/admin/product'>
                                <IoMdCreate /> Create
                            </Link>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Link to='/admin/orders'>
                    <FaThList /> Orders
                </Link>
                <Link to='/admin/users'>
                    <HiUsers /> Users
                </Link>
                <Link to='/admin/reviews'>
                    <MdReviews /> Reviews
                </Link>
            </div>
        </div>
    );
};

export default Sidebar;
